import { Button, Modal } from "@ews-admin/global-design-system";
import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

type LicenceModalProps = {
  isOpen: boolean;
  onClose: () => void;
};

export const LicenceModal: React.FC<LicenceModalProps> = ({
  isOpen,
  onClose,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleGoToLicence = () => {
    navigate("/manager/licence");
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title={t("licence.modal.title")}>
      <p className="text-gray-600">{t("licence.modal.body")}</p>
      <div className="mt-6 flex flex-col-reverse gap-2 sm:flex-row sm:justify-end">
        <Button variant="ghost" onClick={onClose}>
          {t("common.close")}
        </Button>
        <Button onClick={handleGoToLicence}>{t("licence.modal.cta")}</Button>
      </div>
    </Modal>
  );
};
